"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _search = _interopRequireDefault(require("@/components/college/search.vue"));
var _courseItem = _interopRequireDefault(require("@/components/college/courseItem.vue"));
var _index = require("@/api/college/index");
var _public = require("@/api/public/public");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    Search: _search.default
  },
  props: {},
  data: function data() {
    return {
      query: {
        courseName: "",
        majorName: '',
        courseType: "",
        pageNum: 1,
        pageSize: 6,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1"
      },
      onlineCourse: [],
      fictitiousCourse: [],
      openCourse: [],
      majorSource: [],
      teachingMaterial: []
    };
  },
  created: function created() {
    this.$store.commit('settings/getwCode', this.$route.params.code);
    // this.getWebLogo()
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getOnlineCourse();
      this.getFictitiousCourse();
      this.getMajorSource();
      // this.getOpenCourse()
      this.getteachingMaterial();
    },
    //专业资源库
    getMajorSource: function getMajorSource() {
      var _this = this;
      (0, _index.majorSourceList)({
        pageNum: 1,
        pageSize: 6,
        emceeCompanyname: this.$route.params.code,
        onState: "1",
        keyWord: this.query.courseName,
        majorName: this.query.majorName
        // provinceId: this.$store.getters.provinceId,
      }).then(function (res) {
        if (res.code === 2000) {
          // for(let i in res.data.list){
          //   if(res.data.list[i].previewPic){
          //     res.data.list[i].previewPic = res.data.list[i].previewPic.substring(0, res.data.list[i].previewPic.indexOf('?'))
          //   }
          // }
          _this.majorSource = res.data.list;
        }
      });
    },
    //新形态教材
    getteachingMaterial: function getteachingMaterial() {
      var _this2 = this;
      (0, _index.peCourseList)({
        courseType: "7",
        pageNum: 1,
        pageSize: 6,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.teachingMaterial = res.data.list;
        }
      });
    },
    //视频公开课
    getOpenCourse: function getOpenCourse() {
      var _this3 = this;
      (0, _index.peCourseList)({
        courseTypeList: ['3', '2', '6', '4', '5'],
        pageNum: 1,
        pageSize: 6,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          for (var i in res.data.list) {
            if (res.data.list[i].courseType == "3") {
              _this3.$set(res.data.list[i], 'courseTypeName', '国家规划教材数字课程');
            } else if (res.data.list[i].courseType == "2") {
              _this3.$set(res.data.list[i], 'courseTypeName', '课程思政示范项目');
            } else if (res.data.list[i].courseType == "6") {
              _this3.$set(res.data.list[i], 'courseTypeName', '公共基础课');
            } else if (res.data.list[i].courseType == "5") {
              _this3.$set(res.data.list[i], 'courseTypeName', '教学能力大赛获奖课程');
            } else if (res.data.list[i].courseType == "4") {
              _this3.$set(res.data.list[i], 'courseTypeName', '班主任大赛获奖课程');
            }
          }
          _this3.openCourse = res.data.list;
        }
      });
    },
    //虚拟仿真
    getFictitiousCourse: function getFictitiousCourse() {
      var _this4 = this;
      (0, _index.peCourseList)({
        courseType: "14",
        pageNum: 1,
        pageSize: 6,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          // for(let i in res.data.list){
          //   if(res.data.list[i].courseImage){
          //     res.data.list[i].courseImage = res.data.list[i].courseImage.substring(0, res.data.list[i].courseImage.indexOf('?'))
          //   }
          // }
          _this4.fictitiousCourse = res.data.list;
        }
      });
    },
    //在线精品课
    getOnlineCourse: function getOnlineCourse() {
      var _this5 = this;
      (0, _index.peCourseList)({
        courseType: "1",
        pageNum: 1,
        pageSize: 6,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          _this5.onlineCourse = res.data.list;
        }
      });
    },
    // 获取版权信息
    getWebLogo: function getWebLogo() {
      var _this6 = this;
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        if (res.code === 2000) {
          _this6.webSite = res.data;
          _this6.$store.commit('settings/getProvinceId', res.data.provinceId);
          _this6.getOnlineCourse();
          _this6.getFictitiousCourse();
          _this6.getMajorSource();
          _this6.getOpenCourse();
          _this6.getteachingMaterial();
        }
      });
    }
  }
};